export const AUDIT_ACTOR_TYPES = ["ADMIN", "USER", "SYSTEM"] as const;
export const AUDIT_ACTIONS = [
  "CREATE",
  "UPDATE",
  "DELETE",
  "READ",
  "LOGIN",
  "LOGOUT",
  "LOGIN_FAILED",
  "PASSWORD_RESET_REQUEST",
  "PASSWORD_RESET",
  "PASSWORD_CHANGE",
  "REFUND",
  "VERIFY",
  "RESET_REQUEST",
  "RESET",
  "PURCHASE",
  "PAYMENT_INITIATED",
  "PAYMENT",
  "PAYMENT_CONFIRMED",
  "PAYMENT_FAILED",
  "REDEEM",
] as const;
export const AUDIT_RESOURCES = [
  "ADMIN",
  "ROLE",
  "CUSTOMER",
  "WALLET",
  "TRANSACTION",
  "ORDER",
  "CART",
  "SHIPMENT",
  "SHIPMENT_ADJUSTMENT",
  "SHIPPING_RATE",
  "TRACKING",
  "QUOTE",
  "SHOP_FOR_ME",
  "PRODUCT",
  "VENDOR",
  "VENDOR_PRODUCT",
  "EXCHANGE_RATE",
  "SERVICE_FEE",
  "PAYMENT_DETAILS",
  "REFERRAL_CONFIG",
  "SUPPORT_TICKET",
  "UPLOAD",
  "TRANSACTION_PIN",
  "SECURITY_QUESTIONS",
  "BIOMETRIC",
  "KYC",
  "BENEFICIARY",
  "FX",
  "VTU",
  "REFERRAL",
] as const;
export type AuditActorType = (typeof AUDIT_ACTOR_TYPES)[number];
export type AuditAction = (typeof AUDIT_ACTIONS)[number];
export type AuditResource = (typeof AUDIT_RESOURCES)[number];
export type AuditDetails = Record<string, unknown>;
export type AuditChanges = {
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
};
export type AuditMetadata = {
  ip?: string;
  path?: string;
  device?: { os?: string; device?: string; browser?: string } | null;
  method?: string;
  success?: boolean;
  duration?: number;
  actorRole?: string;
  userAgent?: string;
};
export type AuditLogType = {
  id: string;
  actorId: string;
  actorType: AuditActorType;
  actorEmail?: string | null;
  actorName?: string | null;
  action: AuditAction;
  resource: AuditResource;
  resourceId?: string | null;
  details?: AuditDetails | null;
  metadata?: AuditMetadata | null;
  changes?: AuditChanges | null;
  createdAt: string;
  updatedAt: string;
};
export type AuditPagination = {
  total: number;
  totalPages: number;
  page: number;
  limit: number;
};
export type AuditFilters = {
  search: string;
  actorId: string;
  actorType: AuditActorType | "";
  action: AuditAction[];
  resource: AuditResource[];
  resourceId?: string;
  startDate?: string;
  endDate?: string;
};
